// extracted by mini-css-extract-plugin
export default {"iconCta":"icon-cta___G1wXs"};